import React from 'react';

import { ISO_DATE_FORMAT } from '@gasbi/shared';
import dayjs from 'dayjs';
import { Navigate } from 'react-router-dom';

import { Pages } from '@/pages';

const ResourceLayout = React.lazy(() => import('./index'));
const ResourceSchedule = React.lazy(() => import('./views/ResourceSchedule'));
const ResourceBatches = React.lazy(() => import('./views/ResourceBatches'));
const ResourceHistory = React.lazy(() => import('./views/ResourceHistory'));
const ResourceSellers = React.lazy(() => import('./views/ResourceSellers'));
const ResourceBatchDetails = React.lazy(
  () => import('@/pages/ResourceBatchDetails'),
);

const resourceRoute = [
  {
    element: <ResourceLayout />,
    children: [
      {
        path: Pages.RESOURCE,
        element: (
          <Navigate
            to={`./${dayjs().format(ISO_DATE_FORMAT)}/${Pages.RESOURCE_BATCHES_PART}`}
            relative='path'
          />
        ),
      },
      {
        path: `${Pages.RESOURCE}/:date`,
        element: (
          <Navigate to={`./${Pages.RESOURCE_BATCHES_PART}`} relative='path' />
        ),
      },
      {
        path: `${Pages.RESOURCE}/:date/${Pages.RESOURCE_SCHEDULE_PART}`,
        element: <ResourceSchedule />,
      },
      {
        path: `${Pages.RESOURCE}/:date/${Pages.RESOURCE_BATCHES_PART}`,
        element: <ResourceBatches />,
      },
      {
        path: `${Pages.RESOURCE}/:date/${Pages.RESOURCE_HISTORY_PART}`,
        element: <ResourceHistory />,
      },
      {
        path: `${Pages.RESOURCE}/:date/${Pages.RESOURCE_SELLERS_PART}`,
        element: <ResourceSellers />,
      },
    ],
  },
  // Full-page lot card — a sibling of the tabs layout, so it renders without the tab chrome.
  {
    path: `${Pages.RESOURCE}/:date/${Pages.RESOURCE_BATCHES_PART}/:resourceId`,
    element: <ResourceBatchDetails />,
  },
];

export default resourceRoute;
